import React from 'react';
import { connect } from 'react-redux';
import { ModalTypes } from '../../models/modal';
import AlertModal from "./AlertModal";
import ConfirmModal from "./ConfirmModal";
import Modal from "./Modal";

interface IProps extends StateProps, DispatchProps {
}

class Modals extends React.Component<IProps, {}> {
  render() {
    const { modalType, ...modalProps } = this.props.modalProps;

    switch (modalType) {
      case ModalTypes.COMMON:
        return <Modal isOpen={true} toggle={this.props.closeModal} {...modalProps} />
      case ModalTypes.ALERT:
        return <AlertModal isOpen={true} toggle={this.props.closeModal} {...modalProps} />
      case ModalTypes.CONFIRM:
        return <ConfirmModal isOpen={true} toggle={this.props.closeModal} {...modalProps} />
      default:
        return null
    }
  }
}

interface StateProps {
  modalProps: any
}

function mapStateToProps(state: any, ownProps: any): StateProps {
  return {
    modalProps: state.modal
  };
}

interface DispatchProps {
  closeModal: () => void
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    closeModal: dispatch.modal.closeModal
  };
}

export default connect<StateProps, DispatchProps, {}>(mapStateToProps, mapDispatchToProps)(Modals);
